export const LOGIN_PATH = "/";
export const RESET_PASSWORD_PATH = "/reset-password";
export const DASHBOARD_PATH = "/dashboard";
export const Members_PATH = "/members";
export const HOUSING_EXPENSE_REQUEST_PATH = "/housing-expense-request";
export const HOUSING_EXPENSE_CREATE_REQUEST_PATH =
  "/housing-expense-request/create-request";
export const HOUSING_DATABASE_PATH = "/property-database";
export const SURVEY_HISTORY_PATH = "/members/:id";
export const HEALTH_PLANS_PATH = "/health-plans";
export const USERS_PATH = "/users";
export const CONFIGURATION_PATH = "/configuration";
